import React from 'react';
import siteContent from '../data/siteContent';
import './Hero.css';

export default function Hero() {
  const { hero } = siteContent;

  return (
    <section id="hero" className="hero">
      <div className="hero-bg-shape" />
      <div className="hero-accent-line" />
      <div className="hero-content">
        <div className="hero-eyebrow">{hero.eyebrow}</div>
        <h1>
          Building <span className="accent">Intelligence,</span><br />
          Seamlessly Integrated
        </h1>
        <p className="hero-sub">{hero.subtext}</p>
        <div className="btn-group">
          <a href="#services" className="btn-primary">Our Services</a>
          <a href="#contact" className="btn-secondary">Get in Touch</a>
        </div>
      </div>
      <div className="hero-stats">
        <div className="stat-item">
          <div className="stat-num">BMS</div>
          <div className="stat-label">Building Mgmt Systems</div>
        </div>
        <div className="stat-item">
          <div className="stat-num">BAS</div>
          <div className="stat-label">Building Auto Systems</div>
        </div>
        <div className="stat-item">
          <div className="stat-num">EPMS</div>
          <div className="stat-label">Electrical Power Mgmt</div>
        </div>
      </div>
    </section>
  );
}
